<template>
  <div name="hrms12x-popup-sendmail" id="hrms12x-popup-sendmail" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <detail-send    v-show="sendMailDisp"
                        :labels="labels"
                        :labelsButton="labelsButton"
                        :data="data"
                        :currentUser="currentUser"
                        :nowLang=" nowLang"
                        :postSendmail="postSendmail"
                        :empmail="empmail"
                        :triggerIndexSelect="triggerIndexSelect"
                        :triggerSuccess="triggerSuccess"
                        :fileName="fileName"
                        :receiveClearDetail="receiveClearDetail" />
        <detail-not-send  v-show="notSendDisp"
                          :labels="labels"
                          :labelsButton="labelsButton"
                          :data="dataNotSend"
                          :columns="columns" />
      </div>
    </div>
  </div>
</template>

<script>
import detailSend from 'components/hrms12x/detailSend'
import detailNotSend from 'components/hrms12x/detailNotSend'
export default {
  name: 'hrms12x-popup-sendmail',
  props: [ 'labels', 'data', 'nowLang', 'labelsButton', 'postSendmail', 'currentUser', 'empmail', 'triggerIndexSelect', 'triggerSuccess', 'fileName', 'receiveClearDetail', 'sendMailDisp', 'notSendDisp', 'dataNotSend', 'columns' ],
  components: {
    detailSend,
    detailNotSend
  }
}
</script>


// WEBPACK FOOTER //
// popupSendMail.vue?5b04cc32